<template>
  <div class="app-alert" :class="{ dismissed, [`app-alert-${variant}`]: true }" >
    <slot />
    <div v-if="dismissible" href="" @click.prevent="onClose" class="app-alert-dismiss"><app-icon icon="x" /></div>
  </div>
</template>
<script lang="ts">
import { Prop, Component } from "vue-property-decorator";
import { BaseComponent } from "@/app/shared/components/base-component/base-component";
import AppIcon from "../app-icon/app-icon.vue";

@Component({
  name: "app-alert",
  components: {
    AppIcon,
  }
})
export default class AppAlert extends BaseComponent {
  @Prop({ default: "info" }) variant!: "danger" | "info" | "warning" | "success";
  @Prop({ default: false }) dismissible!: boolean;

  dismissed = false;

  onClose() {
    this.dismissed = true;
  }
}
</script>
<style lang="scss">
@import "@/scss/_colors.scss";

.app-alert {
  border-radius: 0;
  position: relative;
  padding: .75rem 1.25rem;
  margin-bottom: 1rem;
  border: 1px solid transparent;

  &-dismiss {
    position: absolute;
    top: 0;
    right: 0;
    font-size: 1.5rem;
    font-weight: 700;
    line-height: 1;
    cursor: pointer;
    padding: .25em;

    &:hover {
      color: var(--default-text-hover-color);
    }
  }
  
  &-success {
    color: var(--success-text-color);
    background-color: var(--success-bg-color);
    border-color: var(--success-border-color);
  }

  &-danger {
    color: var(--danger-text-color);
    background-color: var(--danger-bg-color);
    border-color: var(--danger-border-color);
  }

  &-warning {
    color: var(--warning-text-color);
    background-color: var(--warning-bg-color);
    border-color: var(--warning-border-color);
  }

  &-info {
    color: var(--info-text-color);
    background-color: var(--info-bg-color);
    border-color: var(--info-border-color);
  }
  &.dismissed {
    display: none;
  }
}
.app-alert ul {
  padding-left: 20px;
}
</style>